const STORAGE_KEY = "allInOnePreferredFrequency";
const VALID_FREQUENCIES = ["YEARLY", "HALF_YEARLY"];

const decodeBase64Url = (segment) => {
  if (!segment) return "";
  const pad =
    segment.length % 4 === 0 ? "" : "=".repeat(4 - (segment.length % 4));
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/") + pad;
  return decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join(""),
  );
};

export const isAllInOneProduct = (product) => {
  if (!product) return false;
  const compact = String(product)
    .trim()
    .toUpperCase()
    .replace(/[-_\s]/g, "");
  return compact === "ALLINONE";
};

export const normalizeAllInOneFrequency = (frequency) => {
  if (!frequency) return null;
  const value = String(frequency).trim().toUpperCase();
  return VALID_FREQUENCIES.includes(value) ? value : null;
};

const readDecodedPayload = (decoded) => {
  if (!decoded) return { product: null, frequency: null };

  const trimmed = decoded.trim();
  if (trimmed.startsWith("{")) {
    try {
      const json = JSON.parse(trimmed);
      return {
        product: json.product || null,
        frequency: json.frequency || null,
      };
    } catch (e) {
      return { product: null, frequency: null };
    }
  }

  const inner = new URLSearchParams(trimmed);
  return {
    product: inner.get("product"),
    frequency: inner.get("frequency"),
  };
};

/**
 * Parse All-in-One campaign params from signup/login URLs.
 * Supports `/signup?q=<base64>` and plaintext `product` + `frequency`.
 * Ignores q/frequency unless the product is All-in-One.
 */
export const parseAllInOneSignupParams = (
  search = typeof window !== "undefined" ? window.location.search : "",
) => {
  const empty = { isAllInOne: false, product: null, frequency: null };
  try {
    const params = new URLSearchParams(search || "");
    let product = params.get("product");
    let frequency = params.get("frequency");
    const q = params.get("q");

    if (q) {
      const decoded = decodeBase64Url(q);
      const payload = readDecodedPayload(decoded);
      if (payload.product) product = payload.product;
      if (payload.frequency) frequency = payload.frequency;
    }

    if (!isAllInOneProduct(product)) {
      return empty;
    }

    return {
      isAllInOne: true,
      product: "ALL-IN-ONE",
      frequency: normalizeAllInOneFrequency(frequency),
    };
  } catch (e) {
    return empty;
  }
};

export const captureAllInOneSignupParams = (
  search = typeof window !== "undefined" ? window.location.search : "",
) => {
  const parsed = parseAllInOneSignupParams(search);
  if (parsed.isAllInOne && parsed.frequency) {
    try {
      sessionStorage.setItem(STORAGE_KEY, parsed.frequency);
    } catch (e) {
      // sessionStorage may be unavailable
    }
  }
  return parsed;
};

export const getAllInOnePreferredFrequency = () => {
  try {
    return normalizeAllInOneFrequency(sessionStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return null;
  }
};

export const getAllInOneLoginUrl = (
  search = typeof window !== "undefined" ? window.location.search : "",
) => {
  const parsed = parseAllInOneSignupParams(search);
  if (!parsed.isAllInOne) {
    return "/login";
  }
  return search ? `/login${search}` : "/login";
};
